import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import { getCustomer } from "@/redux/modules/api/data/customer/customer.selectors";
import { set } from "@/redux/modules/value/wishlistSidebar/wishlistSidebar.module";
import { isSidebarVisible } from "@/redux/modules/value/wishlistSidebar/wishlistSidebar.selectors";

import WishlistMenuButton from "./wishlistMenuButton.component";

const WishlistMenuButtonContainer = () => {
    const dispatch = useThunkDispatch();
    const isVisible = useSelector(isSidebarVisible);
    const customer = useSelector(getCustomer);

    const isLoggedIn = !!(customer && !customer.guest);

    return (
        <>
            {isLoggedIn && (
                <WishlistMenuButton
                    handleClick={() => {
                        if (!isVisible) {
                            dispatch(
                                set({
                                    visible: true
                                })
                            );
                        }
                    }}
                />
            )}
        </>
    );
};

export { WishlistMenuButtonContainer };
